import { Role } from 'src/api/endpoints/users/users.types.new';
import { baseApi, QueryPayload } from 'src/api';

export type CurrentUser = {
    id: number;
    avatar: string | null;
    role: Role;

    username: string;

    firstname: string | null;
    surname: string | null;
    patronymic: string | null;

    defaultBranchId: number;

    permissions: {
        canBeEditMaterials: boolean;
        canBeEditSubject: boolean;
    };
};

export type TokensPair = {
    accessToken: string;
    refreshToken: string;
    userId: string;
};

const apiModule = baseApi.injectEndpoints({
    endpoints: builder => ({
        whoami: builder.query<CurrentUser, void>({
            providesTags: ['CurrentUser'],
            query: (): QueryPayload => ({
                url: '/auth/whoami',
                method: 'GET',
                errorMessage: 'Не удалось получить информацию о себе',
            }),
        }),

        login: builder.mutation<
            TokensPair,
            { body: { username: string; password: string } }
        >({
            invalidatesTags: (_r, e) => {
                if (e) return [];
                return ['CurrentUser'];
            },
            query: ({ body }): QueryPayload => ({
                url: '/auth/login',
                data: { login: body.username, password: body.password },
                method: 'POST',
                errorMessage: 'Неверный логин или пароль',
            }),
        }),
    }),
});

export const { useWhoamiQuery, useLoginMutation } = apiModule;
